import { FaFacebook, FaFacebookF, FaInstagram, FaMapMarkerAlt, FaYoutube } from "react-icons/fa"
import "../assets/css/footer.css"
import { useState } from "react"
import { MdCall } from "react-icons/md"

const Footer = () => {
    const [showMap, setShowMap] = useState(false)
    return (
        <>
        <footer className="">
            <div class="d-flex justify-content-center align-items-center main-footer flex-column">
                <a onClick={()=>setShowMap(true)} className="footer-contact sm-text_ cursor-pointer" title="Click to view map"> 
                    <FaMapMarkerAlt /> Butwal, Nepal
                </a>
                <div className="mt-1 mb-3 sm-text_">
                    <a href="tel:9802733392" className="footer-contact" title="Call to 9802733392"> 
                        <MdCall /> 9802733392
                    </a>
                </div> 
                <div class="footer-container text-center position-relative d-flex flex-column w-100 py-0">
                    <div class="mb-1 copyright-text">
                    Copyright © 2024 Siddhartha Cable Car 
                    </div>
                    <div>
                        <a class="footer-link footer-text2"
                            title="Privacy Policy"
                            href="https://www.siddharthacablecar.com.np/privacy-policy">Privacy Policy&nbsp;</a>&nbsp;<a
                            class="footer-link footer-text2"
                            title="Terms and Condition"
                            href="https://www.siddharthacablecar.com.np/terms-condition">Terms &amp; Condition&nbsp;</a>&nbsp;<a
                            class="footer-link footer-text2"
                            title="Technical Support"
                            href="https://www.siddharthacablecar.com.np/technical-support">Technical Support</a>
                    </div>
                    <div class="footer-brands">
                        <a href="https://www.facebook.com/profile.php?id=61564964241755"title="Facebook" target="_blank">
                            <i class="fa-brands fa-facebook-f"
                                aria-hidden="true">
                                <FaFacebookF />
                            </i>
                            </a>
                        <a href="https://www.youtube.com/@siddharthacablecar" title="YouTube" target="_blank">
                            <i class="fa-brands fa-youtube">
                                <FaYoutube />
                            </i>
                            </a>
                        <a href="https://www.instagram.com/siddhartha_cablecar?igsh=MWwwNzJveWlwaHh2YQ%3D%3D&utm_source=qr" title="Instagram" target="_blank">
                            <i
                                class="fa-brands fa-instagram me-0">
                                <FaInstagram />
                            </i>
                        </a>
                    </div>
                </div>
            </div>
            <div className={showMap ? 'modal my-modal fade show' : 'modal my-modal fade'} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"><FaMapMarkerAlt /> Siddhartha Cable Car</h5>
                            <button type="button" className="btn-close" 
                                onClick={()=>setShowMap(false)}
                                aria-label="Close"></button>
                        </div>
                        
                        <div className="modal-body">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.6820316621565!2d83.46210720565516!3d27.710205946958865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3996871ce57c5caf%3A0x3d14e044e0b8b7d4!2sSiddhartha%20Cable%20Car%20Lower%20Station!5e0!3m2!1sen!2snp!4v1706859521824!5m2!1sen!2snp" 
                            width="100%" height="400" style={{'border':'1px solid #ddd'}} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>   
        </footer>
     </>
    )
}

export default Footer